import React, { useEffect, useState } from "react";

interface TagFormProps {
  onSave: (tag: { _id?: string; name: string; color: string }) => void;
  initialTag?: { _id?: string; name: string; color: string } | null;
  onCancel?: () => void;
}

const TagForm: React.FC<TagFormProps> = ({ onSave, initialTag, onCancel }) => {
  const [name, setName] = useState("");
  const [color, setColor] = useState("#000000");

  useEffect(() => {
    if (initialTag) {
      setName(initialTag.name);
      setColor(initialTag.color);
    }
  }, [initialTag]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ _id: initialTag?._id, name, color });
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border rounded mt-4 bg-gray-50">
      <div className="mb-2">
        <label className="block">Nom du tag :</label>
        <input
          className="border p-1 w-full"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="mb-2">
        <label className="block">Couleur :</label>
        <input
          type="color"
          className="w-16 h-10 border"
          value={color}
          onChange={(e) => setColor(e.target.value)}
        />
      </div>

      <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded mr-2">
        {initialTag ? "Mettre à jour" : "Créer"}
      </button>
      {onCancel && (
        <button
          type="button"
          className="px-4 py-2 bg-gray-400 text-white rounded"
          onClick={onCancel}
        >
          Annuler
        </button>
      )}
    </form>
  );
};

export default TagForm;
